import { defineMessages } from 'react-intl';

export default defineMessages({
  itemCount: {
    id: 'MultiSelect.itemCount',
    defaultMessage: '{count} items selected',
  },
});
